import DateFormats from './DateFormats';
import {Capitalize, CapitalizeCamelCase} from "./Capitalize";
import YesNoValue from "./YesNoValue";
import LinkyTrust from './LinkyTrust';
import Currency from "./Currency";
import BusinessDateFormats from './BusinessDateFormats/BusinessDateFormats';
import formatDuration from "./formatDuration";
import addExternalLinkPrefix from "./addExternalLinkPrefix";
import fileType from "@/modules/common/filters/fileType";
export {BusinessDateFormats};

export default {
  DateFormats,
  Capitalize,
  CapitalizeCamelCase,
  YesNoValue,
  LinkyTrust,
  Currency,
  BusinessDateFormats,
  formatDuration,
  addExternalLinkPrefix,
  fileType
}
